import { ReactElement } from "react";
import { ICaster, IPanelProps } from "./types";
import TextField from "@mui/material/TextField";
import RowComponent from "../../components/rowComponent";
import { cloneObject } from "../../../../system/utils";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const CasterPanel = ({ value, property, onChange }: IPanelProps<ICaster>): ReactElement => {

  const onChangeValue = (prop: keyof ICaster, selectedValue: any) => {
    const newValue = cloneObject(value);

    newValue[prop].value = selectedValue;
    onChange(property, newValue);
  };

  const onChangeComment = (prop: keyof ICaster, comment: string) => {
    const newValue = cloneObject(value);

    newValue[prop].comment = comment;
    onChange(property, newValue);
  };

  return (
    <div className="display-flex-column gap-1 p-1">
      <RowComponent title="Non-Free Opens" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.nonFreeOpens.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("nonFreeOpens", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.nonFreeOpens.comment}
            fullWidth={true}
            onChange={event => onChangeComment("nonFreeOpens", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Breakouts" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.breakouts.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("breakouts", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.breakouts.comment}
            fullWidth={true}
            onChange={event => onChangeComment("breakouts", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Overflow" ratio={.2} >
        <div className="row-content-2">
          <ToggleButtonGroup
            fullWidth={true}
            value={value.overflow.value}
            exclusive={true}
            onChange={(_event, selectedValue) => onChangeValue("overflow", selectedValue)}>
            <ToggleButton value={true} >YES</ToggleButton>
            <ToggleButton value={false} >NO</ToggleButton>
          </ToggleButtonGroup>
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.overflow.comment}
            fullWidth={true}
            onChange={event => onChangeComment("overflow", event.target.value)}
          />
        </div>
      </RowComponent>
      <RowComponent title="Heats on the tundish" ratio={.2}>
        <div className="row-content-2">
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            type="number"
            value = {value.heatsOnTheTundish.value}
            fullWidth={true}
            onChange={event => onChangeValue("heatsOnTheTundish", event.target.value)}
          />
          <TextField
            variant="outlined"
            placeholder="to be filled..."
            multiline={true}
            minRows={4}
            maxRows={4}
            value = {value.heatsOnTheTundish.comment}
            fullWidth={true}
            onChange={event => onChangeComment("heatsOnTheTundish", event.target.value)}
          />
        </div>
      </RowComponent>
    </div>
  );
};

export default CasterPanel;